import { render, staticRenderFns } from "./AddTextForm.vue?vue&type=template&id=2a773517&scoped=true"
import script from "./AddTextForm.vue?vue&type=script&lang=js"
export * from "./AddTextForm.vue?vue&type=script&lang=js"
import style0 from "./AddTextForm.vue?vue&type=style&index=0&id=2a773517&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a773517",
  null
  
)

export default component.exports